export const statesList = [
    'Alabama',
    'Alaska',
    'American Samoa',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'District Of Columbia',
    'Federated States Of Micronesia',
    'Florida',
    'Georgia',
    'Guam',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Marshall Islands',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Northern Mariana Islands',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Palau',
    'Pennsylvania',
    'Puerto Rico',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virgin Islands',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
]

export const shortCodeStatesList = [
    { shortcode: 'AL', state: 'Alabama' },
    { shortcode: 'AK', state: 'Alaska' },
    { shortcode: 'AS', state: 'American Samoa' },
    { shortcode: 'AZ', state: 'Arizona' },
    { shortcode: 'AR', state: 'Arkansas' },
    { shortcode: 'CA', state: 'California' },
    { shortcode: 'CO', state: 'Colorado' },
    { shortcode: 'CT', state: 'Connecticut' },
    { shortcode: 'DE', state: 'Delaware' },
    { shortcode: 'DC', state: 'District Of Columbia' },
    { shortcode: 'FM', state: 'Federated States Of Micronesia' },
    { shortcode: 'FL', state: 'Florida' },
    { shortcode: 'GA', state: 'Georgia' },
    { shortcode: 'GU', state: 'Guam' },
    { shortcode: 'HI', state: 'Hawaii' },
    { shortcode: 'ID', state: 'Idaho' },
    { shortcode: 'IL', state: 'Illinois' },
    { shortcode: 'IN', state: 'Indiana' },
    { shortcode: 'IA', state: 'Iowa' },
    { shortcode: 'KS', state: 'Kansas' },
    { shortcode: 'KY', state: 'Kentucky' },
    { shortcode: 'LA', state: 'Louisiana' },
    { shortcode: 'ME', state: 'Maine' },
    { shortcode: 'MH', state: 'Marshall Islands' },
    { shortcode: 'MD', state: 'Maryland' },
    { shortcode: 'MA', state: 'Massachusetts' },
    { shortcode: 'MI', state: 'Michigan' },
    { shortcode: 'MN', state: 'Minnesota' },
    { shortcode: 'MS', state: 'Mississippi' },
    { shortcode: 'MO', state: 'Missouri' },
    { shortcode: 'MT', state: 'Montana' },
    { shortcode: 'NE', state: 'Nebraska' },
    { shortcode: 'NV', state: 'Nevada' },
    { shortcode: 'NH', state: 'New Hampshire' },
    { shortcode: 'NJ', state: 'New Jersey' },
    { shortcode: 'NM', state: 'New Mexico' },
    { shortcode: 'NY', state: 'New York' },
    { shortcode: 'NC', state: 'North Carolina' },
    { shortcode: 'ND', state: 'North Dakota' },
    { shortcode: 'MP', state: 'Northern Mariana Islands' },
    { shortcode: 'OH', state: 'Ohio' },
    { shortcode: 'OK', state: 'Oklahoma' },
    { shortcode: 'OR', state: 'Oregon' },
    { shortcode: 'PW', state: 'Palau' },
    { shortcode: 'PA', state: 'Pennsylvania' },
    { shortcode: 'PR', state: 'Puerto Rico' },
    { shortcode: 'RI', state: 'Rhode Island' },
    { shortcode: 'SC', state: 'South Carolina' },
    { shortcode: 'SD', state: 'South Dakota' },
    { shortcode: 'TN', state: 'Tennessee' },
    { shortcode: 'TX', state: 'Texas' },
    { shortcode: 'UT', state: 'Utah' },
    { shortcode: 'VT', state: 'Vermont' },
    { shortcode: 'VI', state: 'Virgin Islands' },
    { shortcode: 'VA', state: 'Virginia' },
    { shortcode: 'WA', state: 'Washington' },
    { shortcode: 'WV', state: 'West Virginia' },
    { shortcode: 'WI', state: 'Wisconsin' },
    { shortcode: 'WY', state: 'Wyoming' },
]
